export const enum RouterLinkType {
    default = 0,
    forward = 1
}


// WEBPACK FOOTER //
// ./src/Enums/RouterLinkType.tsx